export default "__VITE_ASSET__QVNTFgtA__"